import { SCRIPTS_PATH } from '~/services/endpoints';
import { createLoginURL } from '../services/keycloak';

// Generate a random string to PKCE value
export const generateRandomString = () => {
  const array = new Uint32Array(28);
  crypto.getRandomValues(array);
  return Array.from(array, (dec) => ('0' + dec.toString(16)).slice(-2)).join('');
};

// Calculate a string SHA-256
const sha256 = async (plain: string) => {
  const encoder = new TextEncoder();
  const data = encoder.encode(plain);
  return crypto.subtle.digest('SHA-256', data);
};

// Convert the hash to Base64 URL-Safe
const base64urlencode = (str: ArrayBuffer) => {
  const base64 = btoa(String.fromCharCode(...new Uint8Array(str)))
    .replace(/\+/g, '-')
    .replace(/\//g, '_');
  const end = base64.indexOf('=');
  return end === -1 ? base64 : base64.slice(0, end);
};

// Generate a PKCE challenge from the verifier.
export const pkceChallengeFromVerifier = async (pkceCodeVerifier: string) => {
  const hashed = await sha256(pkceCodeVerifier);
  return base64urlencode(hashed);
};

// Redirects to the Keycloak login page
export const redirectToLogin = async () => {
  const pkceCodeVerifier = generateRandomString();
  localStorage.setItem("pkceCodeVerifier", pkceCodeVerifier);
  const cleanRedirectUri = `${window.location.origin}${SCRIPTS_PATH}`;
  const loginUrl = await createLoginURL(cleanRedirectUri, pkceCodeVerifier);
  window.location.href = loginUrl;
};

export const stripOauthParamsFromUrl = (url: string) => {
  const currentUrl = new URL(url);
  currentUrl.searchParams.delete('code');
  currentUrl.searchParams.delete('session_state');
  return currentUrl.toString();
};

export const setTokenInSessionStorage = (accessToken: string, refreshToken: string, expiresIn: string) => {
  sessionStorage.setItem('access_token', accessToken);
  sessionStorage.setItem('refresh_token', refreshToken);
  sessionStorage.setItem('expires_in', expiresIn);
};